export const MODAL__ACTIONS = {
  OPEN: "OPEN",
};

export const AUTHENTICATION__ACTIONS = {
  LOGIN: "LOGIN",
  RESET: "RESET",
  CODEVERIFY: "CODEVERIFY",
  REGISTER: "REGISTER",
  VERIFYACCOUNT: "VERIFYACCOUNT",
  PASSRESET: "PASSRESET",
  LOGOUT: "LOGOUT",
  SUBMITOTP: "SUBMITOTP",
  SENDREGISTEROTP: "SENDREGISTEROTP",
  FORGETPASSWORDCODE: "FORGETPASSWORDCODE",
  SENTFORGETPASSOTP: "SENTFORGETPASSOTP",
  FORGETPASSWORDRESET: "FORGETPASSWORDRESET",
};

export const LOGOUT__DIALOG__ACTIONS = {
  SHOWDIALOG: "SHOWDIALOG",
  HIDEDIALOG: "HIDEDIALOG",
};

export const DASHBOARD__ACTIONS = {
  PARTNERSUMMARY: "PARTNERSUMMARY",
};

export const PARTNERCOMMISSION__ACTIONS = {
  PARTNERCOMMISSIONSTATISTICS: "PARTNERCOMMISSIONSTATISTICS",
  PARTNERCOMMISSIONWITHDRAWAL: "PARTNERCOMMISSIONWITHDRAWAL",
  PARTNERTRANSFER: "PARTNERTRANSFER",
};

export const PROFILE__ACTIONS = {
  PROFILE: "PROFILE",
  FETCHDOCUMENTS: "FETCHDOCUMENTS",
  IDENTITYVERIFICATION: "IDENTITYVERIFICATION",
  RESIDENCEVERIFICATION: "RESIDENCEVERIFICATION",
  CHANGETHEME: "CHANGETHEME",
  GETTUTORIALS: "GETTUTORIALS"
};

export const TRADINGHISTORY__ACTIONS = {
  CLIENTLIVETRADESREPORTS: "CLIENTLIVETRADESREPORTS",
  CLIENTCLOSEDTRADESREPORTS: "CLIENTCLOSEDTRADESREPORTS",
};

export const TRADINGACCTYPES__ACTIONS = {
  TRADINGACCTYPES: "TRADINGACCTYPES",
};

export const CLIENTTRANSACTIONREPORTS__ACTIONS = {
  TRANSACTIONREPORTS: "TRANSACTIONREPORTS",
};

export const FAQS__ACTIONS = {
  FAQS: "FAQS",
};

export const COMPANYINFO__ACTIONS = {
  COMPANYINFO: "COMPANYINFO",
};


export const AGREEMENT__ACTIONS = {
  NOTACCEPTEDAGREEMENTS: "NOTACCEPTEDAGREEMENTS",
  AGREEMENTHISTORIES: "AGREEMENTHISTORIES",
  UPLOADAGREEMENTFILE: "UPLOADAGREEMENTFILE",
};

export const ALLACCOUNTSSUMMARY__ACTIONS = {
  ALLACCOUNTSSUMMARY: "ALLACCOUNTSSUMMARY",
  CLINTSSUMMARY: "CLINTSSUMMARY",
};

export const CLIENTTREE__ACTIONS = {
  CLIENTTREE: "CLIENTTREE",
};

export const DRONEVIEW__ACTIONS = {
  DRONEVIEW: "DRONEVIEW",
};

export const PARTNERPROFILE__ACTIONS = {
  PARTNERPROFILE: "PARTNERPROFILE",
};

export const PAYMENTMETHODS__ACTIONS = {
  PAYMENTMETHODS: "PAYMENTMETHODS",
};

export const TRADINGACCOUNTSTOTRANSFER__ACTIONS = {
  TRADINGACCOUNTSTOTRANSFER: "TRADINGACCOUNTSTOTRANSFER",
  INTERNALTRANSFERSENDOTP: "INTERNALTRANSFERSENDOTP",
  CONFIRMINTERNALTRANSFER: "CONFIRMINTERNALTRANSFER",
  BANKTRANSFERSENDOTP: "BANKTRANSFERSENDOTP",
  CONFIRMBANKTRANSFER: "CONFIRMBANKTRANSFER",
  CLIENTLEVELEARNINGS: "CLIENTLEVELEARNINGS",

  //crypto transfer
  ALLCRYPTOADDRESS: "ALLCRYPTOADDRESS",
  TRANSFERTOCRYPTOSENDOTP: "TRANSFERTOCRYPTOSENDOTP",
  CONFIRMTRANSFERTOCRYPTO: "CONFIRMTRANSFERTOCRYPTO",
  //all tranfer
  ALLBANKADDRESS: "ALLBANKADDRESS",
};

export const COMMISSIONSTATS__ACTIONS = {
  COMMISSIONSTATS: "COMMISSIONSTATS",
  LEVELWISECOMMISSIONEARNING: "LEVELWISECOMMISSIONEARNING",
};

export const MARKETTINGTOOLS__ACTIONS = {
  BANNERCATEGORIES: "BANNERCATEGORIES",
  BANNERSIZES: "BANNERSIZES",
  BANNERS: "BANNERS",
  CREATEBANNER: "CREATEBANNER",
  DELETEBANNER: "DELETEBANNER",
  UPDATEBANNER: "UPDATEBANNER",
  BANNERSIZECREATE: "BANNERSIZECREATE",
  BANNERSIZEUPDATE: "BANNERSIZEUPDATE",
  BANNERSIZEDELETE: "BANNERSIZEDELETE",
};

export const NOTIFICATIONS__ACTIONS = {
  NOTIFICATIONS: "NOTIFICATIONS",
  MARK_ALL_AS_READ: "MARK_ALL_AS_READ",
  SET_POLLING_INTERVAL: "SET_POLLING_INTERVAL",
  STOP_POLLING_INTERVAL: "STOP_POLLING_INTERVAL",
  UPDATE: "UPDATE"
};

export const ASSACCTYPES__ACTIONS = {
  ASSIGNEDACCTYPES: "ASSIGNEDACCTYPES",
  CURRENCYGROUPS: "CURRENCYGROUPS",
  COMRATRESTREE: "COMRATRESTREE",
  VIEWCOMRATRES: "VIEWCOMRATRES",
  UPDATECOMMISSIONRATES: "UPDATECOMMISSIONRATES",
};

export const PUBLIC_LOGIN__ACTIONS = {
  LOGINPAGEINFO: "LOGINPAGEINFO",
};

export const TRADEMASTER__ACTIONS = {
  INVESTORACCOUNTS: "INVESTORACCOUNTS",
  AFFILIATESUMMARY: "AFFILIATESUMMARY",
  MT5ACCOUNTDETAILS: "MT5ACCOUNTDETAILS",
  LEVELCLIENTS: "LEVELCLIENTS",
  MT5TRANSACTIONS: "MT5TRANSACTIONS"
}